import {
    ActionPointInfo,
    Middleware,
} from '@tencent/workbench';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { SLIDE_ADAPTER } from '../editor-adpater/slide-adapter';
import { FormItemName } from '../drawer/constants';
import { getCommonDisabledState } from './toolbar-middleware';
import { getFormDisabledItems } from './form/disabled';
import { getFormHideItems } from './form/hide';
import type {
    IActionPointInfo,
    IMiddleware } from '@tencent/workbench';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import type { IItem, IItems } from './form/form.interface';
import type { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import EmptyModel from '@src/slide/domain/ui-model/element-modeles/empty-model';

const FirstInfoItem = [
    FormItemName.FILL_SELECT, FormItemName.FILL_PRESET, FormItemName.LAYOUT_CHANGE,
    FormItemName.LAYOUT, FormItemName.BORDER_SELECT, FormItemName.BORDER_PRESET,
    ActionType.ALIGN_HORIZONTALLT_LEFT, FormItemName.PLACEHOLDER_FORMAT,
    ChartFormItemKey.CHART_LINE_SELECT, ChartFormItemKey.CHART_FILL_SELECT,
    ChartFormItemKey.CHART_GLOBAL_LINE_SELECT, ChartFormItemKey.CHART_GLOBAL_FILL_SELECT,
    FormItemName.SHADOW, FormItemName.HEIGHT, FormItemName.FONT_FILL_PRESET, FormItemName.FONT_FILL_SELECT,
    FormItemName.FONT_SHADOW, FormItemName.FONT_ADJUST_TEXT,
];
/**
 * 处理侧边栏中间件的一些逻辑，包括置灰和隐藏能力
 */
export default class FormBaseMiddleware {
    private static firstItemInfos: string[] = FirstInfoItem;    // 记录首个设置项名称和属于的设置项区域-置灰middleware
    private static disabledItems: IItems = {};    // 置灰项
    private static hideItems: IItems = {};    // 隐藏项
    private static selectionService: ISelectionService;

    public static init(selectionService: ISelectionService) {
        this.selectionService = selectionService;
    }

    /**
     * 获取某个设置项的置灰态
     */
    public static getFormDisabledItems(name: string): IItem | undefined {
        // 如果重新从第一个设置项开始获取中间状态，则更新缓存
        if (!this.firstItemInfos || this.firstItemInfos.includes(name)) {
            // 选中备注时，侧边栏展示为背景设置项
            let model = this.selectionService.getSelectedModel();
            if (model?.type === UIModelType.NOTE) {
                model = new EmptyModel({});
            }
            this.disabledItems = getFormDisabledItems(model as IElementBaseModel | IMultiplyModel);
        }
        return this.disabledItems?.[name];
    }

    /**
     * 获取某个设置项的隐藏态
     */
    public static getFormHideItems(name: string): IItem | undefined {
        // 如果重新从第一个设置项开始获取中间状态，则更新缓存
        if (!this.firstItemInfos || this.firstItemInfos.includes(name)) {
            // 选中备注时，侧边栏展示为背景设置项
            let model = this.selectionService.getSelectedModel();
            if (model?.type === UIModelType.NOTE) {
                model = new EmptyModel({});
            }
            this.hideItems = getFormHideItems(model as IElementBaseModel | IMultiplyModel);
        }
        return this.hideItems?.[name];
    }
}


@Middleware({
    adapters: [SLIDE_ADAPTER],
})
export class FormDisabledMiddleware implements IMiddleware {
    public use(@ActionPointInfo() info: IActionPointInfo) {
        // 先获取disabledItem是为了根据是否为首个设置项而更新缓存
        const disabledItem = FormBaseMiddleware.getFormDisabledItems(info.name);
        if (getCommonDisabledState(info.name)) return true;
        if (typeof disabledItem === 'undefined') {
            return false;
        }
        return disabledItem();
    }
}

/**
 * 权限中间件
 * 按钮的公用隐藏状态
 */
@Middleware({
    adapters: [SLIDE_ADAPTER],
})
export class FormHideMiddleware implements IMiddleware {
    public use(@ActionPointInfo() info: IActionPointInfo) {
        const hideItem = FormBaseMiddleware.getFormHideItems(info.name);
        if (typeof hideItem === 'undefined') {
            return false;
        }
        return hideItem();
    }
}
